import React from "react";
import DistrictList from "../DistrictList/DistrictList";
import {
  CardContent,
  Typography,
  Box,
  Grid,
  Button,
  useTheme,
} from "@mui/material";
import {
  cardContent,
  productName,
  variantBox,
  priceText,
  button,
  gridContainer,
  gridItem,
  priceContainer,
} from "./ProductVariants.styles";

function ProductVariants({
  product,
  toggleDistricts,
  activeVariant,
  handleDistrictClick,
}) {
  const theme = useTheme();

  return (
    <CardContent sx={cardContent(theme)}>
      <Typography variant="h6" sx={productName}>
        {product?.name}
      </Typography>

      {product.variants.map(({ _id: variantId, weight, price, districts }) => (
        <Box key={variantId} sx={variantBox}>
          <Grid container spacing={2} sx={gridContainer}>
            <Grid item xs={6} sx={gridItem}>
              <Typography sx={priceText}>📦{weight}г.</Typography>
            </Grid>
            <Grid item xs={6} sx={priceContainer}>
              <Typography sx={priceText}>💰 {price}</Typography>
            </Grid>
          </Grid>

          <Button
            fullWidth
            color={theme.palette.mode === "light" ? "primary" : "secondary"}
            onClick={() => toggleDistricts(variantId)}
            sx={button(theme)}
            className={activeVariant === variantId ? "active" : ""}
          >
            {activeVariant === variantId ? "Скрыть районы" : "Показать районы"}
          </Button>

          {activeVariant === variantId && (
            <DistrictList
              districts={districts}
              variantId={variantId}
              handleDistrictClick={handleDistrictClick}
              product={product}
              price={price}
            />
          )}
        </Box>
      ))}
    </CardContent>
  );
}

export default ProductVariants;
